// File: app.module.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root module for the app.
// Other Contributors: Brandon Shreve

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { MescModule } from './components/mesc/mesc.module';

import { AppService } from './app.service';
import { AuthenticationService } from './auth.service';

import { AppComponent } from './app.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { BreadcrumbsComponent } from './shared/breadcrumbs/breadcrumbs.component';
import { PhfModule } from './components/phf/phf.module';
import { NgModule } from '@angular/core';



@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        MatToolbarModule,
        MatSidenavModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        SharedModule,
        MescModule,
        PhfModule,
    ],
    declarations: [
        AppComponent,
        LoggedOutComponent,
        NotFoundComponent,
        UnauthorizedComponent,
        BreadcrumbsComponent,
        UserProfileComponent,
    ],
    providers: [
        AppService,
        AuthenticationService,
        HttpClientModule
    ],
    exports: [
        UserProfileComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
